export default __webpack_public_path__ + "static/media/BMW.a90cf69d.png";